import { render, staticRenderFns } from "./SetupCanvas.vue?vue&type=template&id=7df57d2a&scoped=true&"
import script from "./SetupCanvas.vue?vue&type=script&lang=js&"
export * from "./SetupCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SetupCanvas.vue?vue&type=style&index=0&id=7df57d2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df57d2a",
  null
  
)

export default component.exports